import { destroyVersionCheckHandler, initVersionCheckHandler } from './versionCheckHandler';

/**
 * Initialize error handlers
 */
export const initErrorHandlers = (): void => {
    initVersionCheckHandler();

    // Cleanup error handlers when the page is unloaded
    window.addEventListener('beforeunload', () => {
        destroyErrorHandlers();
    });
};

/**
 * Cleanup error handlers
 */
export const destroyErrorHandlers = (): void => {
    destroyVersionCheckHandler();
};
